





















import Component from "vue-class-component";
import MedicalInvoiceBase from "@/components/medicalTransmissionEdit/invoice/MedicalInvoiceBase";
import Burden from "@/components/medicalTransmissionEdit/invoice/part/Burden.vue";
import InvoiceInsBurdens from "@/components/medicalTransmissionEdit/invoice/part/InvoiceInsBurdens.vue";
import Money from "@/components/medicalTransmissionEdit/invoice/part/Money.vue";

@Component({
  components: {
    Burden,
    InvoiceInsBurdens,
    Money
  }
})
export default class MedicalInvoiceRev1 extends MedicalInvoiceBase {}
